import React, { useEffect, useState, useRef } from 'react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import { getIndustries, createIndustry, updateIndustry, deleteIndustry } from '../api/industryAPI';
import { useFormBuilder } from '../utils/useFormBuilder';
import $ from 'jquery';
import { Icon } from '@iconify/react';

const IndustryLayer = () => {
  const userProfile = useUserProfile();
  const [list, setList] = useState([]);
  const [formData, setFormData] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const inputFields = [
    { field: 'name', label: 'Name', type: 'text', size: 6, required: true },
    { field: 'icon', label: 'Icon', type: 'text', size: 6 },
  ];

  const { renderField } = useFormBuilder(inputFields, formData, setFormData, errors);

  const fetchData = async () => { const data = await getIndustries(); setList(data); };

  useEffect(() => { fetchData(); }, []);

  useEffect(() => {
    if (dtRef.current) dtRef.current.destroy();
    if (list.length > 0) { dtRef.current = $(tableRef.current).DataTable({ pageLength:25, dom:'rtp' }); }
    return () => dtRef.current?.destroy(true);
  }, [list]);

  useEffect(() => { dtRef.current?.search(search).draw(); }, [search]);

  const validate = () => {
    const errs = {};
    if (!formData.name?.trim()) errs.name = 'Required';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    const clean = {};
    for (const k in formData) if (formData[k] !== null && typeof formData[k] !== 'object') clean[k] = formData[k];
    if (editingId) await updateIndustry(editingId, clean); else await createIndustry(clean);
    setShowModal(false); setEditingId(null); if (dtRef.current){ dtRef.current.destroy(); dtRef.current=null; }
    setFormData({}); await fetchData();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete item?')) return;
    await deleteIndustry(id);
    if (dtRef.current){ dtRef.current.destroy(); dtRef.current=null; }
    await fetchData();
  };

  return (
    <div className='card h-100 p-0 rounded-0'>
      <div className='card-header d-flex justify-content-between p-3'>
        <input type='text' className='form-control w-auto' placeholder='Search...' value={search} onChange={e=>setSearch(e.target.value)} />
        {userProfile?.privileges?.includes('industry:create') && (
          <button className='btn btn-primary btn-sm d-flex align-items-center gap-2' onClick={()=>{setFormData({});setEditingId(null);setShowModal(true);}}>
            <Icon icon='ic:baseline-plus' className='icon text-xl' /> Add Industry
          </button>
        )}
      </div>
      <div className='card-body p-0'>
        <div className='table-responsive scroll-sm' style={{ maxHeight: "calc(100vh - 199px)" }}>
          <table ref={tableRef} className='table bordered-table mb-0'>
            <thead><tr><th>Name</th><th>Icon</th><th>Actions</th></tr></thead>
            <tbody>
              {list.map(item=> (
                <tr key={item.id}>
                  <td><strong>{item.name}</strong></td>
                  <td><Icon 
                    icon={item.icon}
                    className='icon line-height-1' 
                    style={{ fontSize: "28px" }}
                  /></td>
                  <td>
                    <div className='d-flex gap-2'>
                      {userProfile?.privileges?.includes('industry:update') && (
                        <button className='w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center' onClick={()=>{setFormData(item);setEditingId(item.id);setShowModal(true);}}>
                          <Icon icon='ic:baseline-edit' className='icon text-xl line-height-1' />
                        </button>
                      )}
                      {userProfile?.privileges?.includes('industry:delete') && (
                        <button className='w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center' onClick={()=>handleDelete(item.id)}>
                          <Icon icon='ic:baseline-delete-outline' className='icon text-xl line-height-1' />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showModal && (
        <div className='modal show d-block' tabIndex='-1'>
          <div className='modal-dialog modal-lg'><div className='modal-content'>
            <div className='modal-header'><h5 className='modal-title'>{editingId?'Edit Industry':'New Industry'}</h5><button className='btn-close' onClick={()=>setShowModal(false)} /></div>
            <div className='modal-body'><div className='row g-3'>{inputFields.map(renderField)}</div></div>
            <div className='modal-footer'><button className='btn btn-secondary' onClick={()=>setShowModal(false)}>Close</button><button className='btn btn-primary' onClick={handleSave}>Save</button></div>
          </div></div>
        </div>
      )}
    </div>
  );
};

export default IndustryLayer;
